import { apiAuthClient } from 'api/helpers';

import type { PatchBoardUserRequestType } from '../types';

export const patchBoardUser = async ({
  pathParams: { organisationId, boardId, boardUserId },
  body,
}: PatchBoardUserRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/users/${boardUserId}`;
  const { data } = await apiAuthClient.patch(url, body);
  return data.data;
};
